import { Navigate, Outlet } from 'react-router-dom';
import { isLoggedIn } from '../utils/auth';
import { useApp } from '../contexts/AppContext';

/**
 * AuthGuard - Protects routes that require authentication
 * Redirects to login page if user is not authenticated
 */
export default function AuthGuard() {
  const { isAuthenticated } = useApp();
  
  // Check both context authentication (for demo mode) and token-based auth (for real API)
  const hasAuth = isAuthenticated || isLoggedIn();
  
  return hasAuth ? <Outlet /> : <Navigate to="/login" replace />;
}
